import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const BurgerMenuIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M13.667 5.5C13.943 5.50018 14.167 5.72397 14.167 6C14.167 6.27603 13.943 6.49982 13.667 6.5H3C2.72386 6.5 2.5 6.27614 2.5 6C2.5 5.72386 2.72386 5.5 3 5.5H13.667Z"
      fill="currentColor"
    />
    <path
      d="M13.667 10.1665C13.943 10.1667 14.167 10.3905 14.167 10.6665C14.167 10.9425 13.943 11.1663 13.667 11.1665H3C2.72386 11.1665 2.5 10.9426 2.5 10.6665C2.5 10.3904 2.72386 10.1665 3 10.1665H13.667Z"
      fill="currentColor"
    />
  </svg>
);
